import { useCallback } from 'react';

import { StackActions, useNavigation } from '@react-navigation/native';

export function useBetslipNavigation() {
    const navigation = useNavigation();

    const navigateToPickslip = useCallback(
        (replace?: boolean, shouldOpenLineupModal?: boolean) => {
            if (replace) {
                navigation.dispatch(StackActions.replace('FantasyPickSlipStack'));
                return;
            }
            navigation.navigate('FantasyPickSlipStack', {
                screen: 'FantasyPickSlip',
                params: { shouldOpenLineupModal },
            });
        },
        [navigation]
    );

    return {
        navigateToPickslip,
    };
}

export type PicksBetslipNavigationContext = ReturnType<typeof useBetslipNavigation>;
